import { render, staticRenderFns } from "./popup-wrap-main.vue?vue&type=template&id=7d8a2065&"
import script from "./popup-wrap-main.vue?vue&type=script&lang=js&"
export * from "./popup-wrap-main.vue?vue&type=script&lang=js&"
import style0 from "./popup-wrap-main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports